module.exports = __webpack_public_path__ + "img/icon-select-company.45000329.svg";